import { render, staticRenderFns } from "./FirstWebinar.vue?vue&type=template&id=65e72bc9&"
import script from "./FirstWebinar.vue?vue&type=script&lang=js&"
export * from "./FirstWebinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports